goog.provide('el8.data.checklistTemplates');

goog.require('el8.model.base');
goog.require('el8.data.model.checklist');
goog.require('el8.service.urls');


el8.data.checklistTemplates = (function() {
    var _class = function(spec) {
        this.populate(spec);
    };
    _class.inheritsFrom(el8.data.model.checklist);
    _class.addStringProperty('name', true);
    _class.addBoolean('default');
    _class.addBoolean('practiceOwned');
    _class.prototype.asSoyMap = function() {
        var m = this.asMap();
        m['isPracticeOwned'] = this.isPracticeOwned();
        return m;
    };

    _class.prototype.getFieldNames = function(gender) {
        var fields = this.getFields();
        return fields.filter(function(a) { 
                    return !a.getGender() || (gender === 'N') || (a.getGender() === gender);
                }).map(function(a) { return a.getName(); });
    };

    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        urlLoad: function() { return el8.service.urls.get('checklistTemplates'); },
        urlFn: function(id) { return el8.service.urls.get('checklistTemplates', [id]); },
        deleteFn: function(item, callbackFn) {
            $.el8_ajax({
                type: 'DELETE',
                url: el8.service.urls.get('checklistTemplates', [item.getId()]),
                success: callbackFn
            });
        },
        sortFn: function(a, b) {
            if (a.getName().toLowerCase() > b.getName().toLowerCase()) { return 1; }
            if (a.getName().toLowerCase() === b.getName().toLowerCase()) { return 0; }
            return -1;
        }
    });
    that.loadByType = function(type, callbackFn) {
        $.el8_ajax({
            type: 'GET',
            url: el8.service.urls.get('checklistTemplates'),
            data: { type: type },
            success: function(data) {
                that.create(data);
                if (callbackFn) { callbackFn(data); }
            }
        });
    };
    that.allType = function(type, suppressDefaults, noSort) {
        var _all = noSort ? that.all() : that.sorted();  // default to sorting results
        var sorted = [];
        for (var i=0; i<_all.length; i++) {
            if (_all[i].getType() === type && (!suppressDefaults || !_all[i].isDefault())) { sorted.push(_all[i]); }
        }
        return sorted;
    };
    that.getTop = function(type, limit) {
        var _all = (type ? that.allType(type, true) : that.sorted());
        return (limit ? _all.slice(0,limit) : _all);
    };
    that.getDefaultByType = function(type) {
        var _all = that.allType(type);
        for (var i=0; i<_all.length; i++) {
            if (_all[i].isDefault()) {
                return _all[i];
            }
        }
        return null;
    };
    return that;
})();

